export default "__VITE_ASSET__CaKbsi0R__"